import { BehaviorSubject } from 'rxjs'

export interface CanScroll {
  left: boolean
  right: boolean
}

export class Scroller {
  private canScrollSubject = new BehaviorSubject<CanScroll>({
    left: false,
    right: false,
  })

  public canScroll$ = this.canScrollSubject.asObservable()

  private resizeObserver = new ResizeObserver(
    () => this.check()
  )

  public constructor(
    public elementToScroll: Element,
    public elementToListenForResize: Element,
    public scrollFactor = 1/2,
    public toleranceInPx = 2,
  ) {
    this.resizeObserver.observe(elementToListenForResize)
  }

  public destroy() {
    this.resizeObserver.disconnect()
  }

  public check(): CanScroll {
    const canScroll = {
      left: this.canScrollLeft(),
      right: this.canScrollRight(),
    }

    this.canScrollSubject.next(canScroll)

    return canScroll
  }

  public scrollLeft() {
    this.scroll(this.elementToScroll.clientWidth * this.scrollFactor * -1)
  }

  public scrollRight() {
    this.scroll(this.elementToScroll.clientWidth * this.scrollFactor)
  }

  private scroll(distanceInPx: number) {
    this.elementToScroll.scrollBy({
      behavior: 'smooth',
      left: distanceInPx,
    })
  }

  private canScrollLeft(): boolean {
    return this.elementToScroll.scrollLeft > this.toleranceInPx
  }

  private canScrollRight(): boolean {
    return this.elementToScroll.scrollWidth - (
      this.elementToScroll.scrollLeft + this.elementToScroll.clientWidth
    ) > this.toleranceInPx
  }
}
